<ng-select
  class="emt-dropdown-v1"
  [placeholder]="placeholder"
  (change)="changeEvent($event)"
  [formControl]="control"
  [closeOnSelect]="true"
  >
  @for (item of items; track item) {
    <ng-option [value]="item[bindValue]" [disabled]="item.disabled">
      {{ item[bindLabel] }}
    </ng-option>
  }
</ng-select>
